import { Paperclip } from 'lucide-react';
import type { AttachmentView } from '@product-portal/shared';

/**
 * Downloadable attachment. The API checks the right to read it: the business
 * route never serves an internal note's file; the product space has its own.
 */
export function AttachmentChip({ attachment, href }: { attachment: AttachmentView; href?: string }) {
  return (
    <a
      href={href ?? `/api/attachments/${attachment.id}`}
      className="inline-flex items-center gap-2 rounded-control border border-border px-3 py-2 text-[13px] text-foreground no-underline hover:text-foreground"
    >
      <Paperclip aria-hidden="true" className="size-4" />
      {attachment.fileName}
    </a>
  );
}
